// Material Kit 2 PRO React pages
import SignInIllustration from "../../pages/auth/login";

export default function SignInIllustrationPage() {
  return <SignInIllustration />;
}
